// extracted by mini-css-extract-plugin
export var article = "VideoPromos-module--article--Zrssb";
export var container = "VideoPromos-module--container--nZkbX";
export var content = "VideoPromos-module--content--th0f9";
export var footer = "VideoPromos-module--footer--qsg+y";
export var headline = "VideoPromos-module--headline--8oJuP";
export var image = "VideoPromos-module--image--YroPh";
export var section = "VideoPromos-module--section--WVEom";
export var subtitle = "VideoPromos-module--subtitle--exfQq";